/**
 * Session recordings for the fund owners: the screen is readable.
 *
 * Password inputs stay masked. Autocapture events still omit element text
 * (mask_all_text on init). Identify stays pseudonymous. Query strings are
 * stripped before send. Recordings live in the Hatzdaka PostHog project.
 */
export const SESSION_RECORDING_OPTIONS = {
  maskAllInputs: false,
  maskInputOptions: { password: true },
} as const;
